// 1. 侧边栏目录功能
const menuIcon = document.querySelector('.menu-icon');
const sidebarTable = document.querySelector('.sidebar-table');
const closeBtn = document.querySelector('.close-btn');
const overlay = document.createElement('div');
overlay.className = 'overlay';
document.body.appendChild(overlay);
menuIcon.addEventListener('click', () => {
  sidebarTable.classList.toggle('open');
  overlay.classList.toggle('active');
});
closeBtn.addEventListener('click', () => {
  sidebarTable.classList.remove('open');
  overlay.classList.remove('active');
});
overlay.addEventListener('click', () => {
  sidebarTable.classList.remove('open');
  overlay.classList.remove('active');
});
sidebarTable.addEventListener('click', (event) => {
  if (event.target.tagName === 'A') {
    sidebarTable.classList.remove('open');
    overlay.classList.remove('active');
  }
});
// 2 & 3. 合并目录点击和滚动联动功能
const sections = document.querySelectorAll('.content h1, .content h2, .content h3, .content h4, .content h5, .content h6');
const tableOfContents = document.getElementById('table-of-contents');
let currentSelected = null;
function updateActiveSection(targetSection = null) {
  let currentSection = targetSection;
  if (!currentSection) {
    const scrollPosition = window.scrollY + 50; // 考虑50px偏移
    let closestSection = null;
    let closestDistance = Infinity;
    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const distance = Math.abs(sectionTop - scrollPosition);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestSection = section;
      }
    });
    currentSection = closestSection;
  }
  if (currentSection) {
    const id = currentSection.id;
    const targetLink = tableOfContents.querySelector(`a[href="#${id}"]`);
    if (targetLink) {
      const targetLi = targetLink.closest('li');
      if (currentSelected !== targetLi) {
        if (currentSelected) {
          currentSelected.classList.remove('selected');
        }
        targetLi.classList.add('selected');
        currentSelected = targetLi;
      }
    }
  }
}
// 目录点击事件
tableOfContents.addEventListener('click', (event) => {
  if (event.target.tagName === 'A') {
    event.preventDefault();
    const targetId = event.target.getAttribute('href').slice(1);
    const targetSection = document.getElementById(targetId);
    if (targetSection) {
      const targetPosition = targetSection.offsetTop - 50; // 距离顶部50px
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
      updateActiveSection(targetSection);
    }
  }
});
// 滚动事件处理
let ticking = false;
window.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      updateActiveSection();
      ticking = false;
    });
    ticking = true;
  }
}, { passive: true });
// 窗口大小改变时更新激活的部分
window.addEventListener('resize', () => updateActiveSection(), { passive: true });
// 页面加载完成后初始化激活的部分
document.addEventListener('DOMContentLoaded', () => updateActiveSection());
// 4. 滚动时添加 CSS 类
let isScrolling = false;
const toggleScrollingClass = () => {
  if (!isScrolling) {
    document.body.classList.add('scrolling');
    isScrolling = true;
  }
}
window.addEventListener('scroll', () => {
  window.requestAnimationFrame(toggleScrollingClass);
}, { passive: true });